(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after')) { customElements.define('before-after', class BeforeAfter extends HTMLElement { connectedCallback() { this.input=this.querySelector('input[type="range"]'); this.input?.addEventListener('input',this.update); this.update() } disconnectedCallback(){this.input?.removeEventListener('input',this.update)} update=()=>{if(this.input)this.style.setProperty('--reveal-position',`${this.input.value}%`)} }) }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('storefront-cart-drawer')) {
    customElements.define('storefront-cart-drawer', class StorefrontCartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.addEventListener('change', this.handleChange)
        this.addEventListener('click', this.handleClick)
        document.addEventListener('cart:updated', this.handleCartUpdated)
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.handleChange)
        this.removeEventListener('click', this.handleClick)
        document.removeEventListener('cart:updated', this.handleCartUpdated)
        this.controller?.abort()
        delete this.dataset.ready
      }
      handleChange = (event) => {
        const input = event.target.closest('input[name="updates[]"]')
        const line = input?.closest('[data-cart-line-key]')
        if (!input || !line) return
        this.changeLine(line.dataset.cartLineKey, Number(input.value), document.activeElement || input)
      }
      handleClick = (event) => {
        const remove = event.target.closest('[data-cart-remove]')
        const line = remove?.closest('[data-cart-line-key]')
        if (!remove || !line) return
        event.preventDefault()
        this.changeLine(line.dataset.cartLineKey, 0, remove)
      }
      handleCartUpdated = (event) => {
        if (event.detail?.source === 'cart-drawer') return
        this.refresh(this.dataset.autoOpen === 'true')
      }
      async changeLine(key, quantity, focusTarget) {
        if (this.loading) return
        const viewState = this.captureViewState(key, focusTarget)
        this.loading = true
        this.setBusy(true)
        this.showError('')
        try {
          const response = await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: [this.dataset.sectionId], sections_url: this.dataset.sectionUrl }),
          })
          const cartData = await response.json()
          if (!response.ok) throw new Error(cartData.description || cartData.message || this.dataset.errorMessage)
          const markup = cartData.sections?.[this.dataset.sectionId]
          if (markup) this.replaceFromMarkup(markup, true, cartData, viewState)
          else await this.refresh(true, cartData, viewState)
        } catch (error) {
          const errorMessage = error.message || this.dataset.errorMessage
          await this.refresh(true, null, viewState)
          this.showError(errorMessage)
          this.setBusy(false)
          this.loading = false
        }
      }
      async refresh(openAfter = false, cartData = null, viewState = null) {
        if (this.refreshing) return
        this.refreshing = true
        try {
          const url = new URL(this.dataset.sectionUrl, window.location.origin)
          url.searchParams.set('section_id', this.dataset.sectionId)
          const response = await fetch(url, { headers: { Accept: 'text/html' } })
          if (!response.ok) throw new Error(this.dataset.errorMessage)
          this.replaceFromMarkup(await response.text(), openAfter, cartData, viewState)
        } catch (error) { this.showError(error.message || this.dataset.errorMessage) }
        finally { this.refreshing = false }
      }
      replaceFromMarkup(markup, openAfter, cartData, viewState = null) {
        const documentFragment = new DOMParser().parseFromString(markup, 'text/html')
        const replacement = documentFragment.querySelector('storefront-cart-drawer')
        const currentContent = this.querySelector('[data-cart-drawer-content]')
        const nextContent = replacement?.querySelector('[data-cart-drawer-content]')
        if (!replacement || !currentContent || !nextContent) throw new Error(this.dataset.errorMessage)
        const dialog = this.querySelector('[data-overlay-dialog]')
        const wasOpen = dialog?.open === true
        currentContent.replaceWith(nextContent)
        this.setBusy(false)
        this.loading = false
        if (cartData) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { ...cartData, source: 'cart-drawer' } }))
        requestAnimationFrame(() => {
          if (viewState && wasOpen) this.restoreViewState(viewState)
          if (openAfter && !wasOpen) document.dispatchEvent(new CustomEvent('overlay:open', { detail: { id: 'MerricrateCart', trigger: document.querySelector('[data-cart-trigger]') } }))
        })
      }
      captureViewState(key, focusTarget) {
        const lines = [...this.querySelectorAll('[data-cart-line-key]')]
        const line = lines.find((item) => item.dataset.cartLineKey === key)
        let focusSelector = 'input[name="updates[]"]'
        if (focusTarget?.matches?.('[data-quantity-minus]')) focusSelector = '[data-quantity-minus]'
        if (focusTarget?.matches?.('[data-quantity-plus]')) focusSelector = '[data-quantity-plus]'
        if (focusTarget?.matches?.('[data-cart-remove]')) focusSelector = '[data-cart-remove]'
        return {
          key,
          lineIndex: Math.max(0, lines.indexOf(line)),
          focusSelector,
          scrollTop: this.querySelector('[data-overlay-dialog]')?.scrollTop || 0,
        }
      }
      restoreViewState(viewState) {
        const dialog = this.querySelector('[data-overlay-dialog]')
        const lines = [...this.querySelectorAll('[data-cart-line-key]')]
        const matchingLine = lines.find((line) => line.dataset.cartLineKey === viewState.key)
        const fallbackLine = lines[Math.min(viewState.lineIndex, Math.max(0, lines.length - 1))]
        const focusTarget = matchingLine?.querySelector(viewState.focusSelector)
          || fallbackLine?.querySelector('input[name="updates[]"]')
          || this.querySelector('[data-overlay-close]')
        focusTarget?.focus({ preventScroll: true })
        if (dialog) dialog.scrollTop = Math.min(viewState.scrollTop, dialog.scrollHeight - dialog.clientHeight)
      }
      setBusy(busy) {
        this.classList.toggle('is-loading', busy)
        this.querySelector('[data-overlay-dialog]')?.setAttribute('aria-busy', busy ? 'true' : 'false')
      }
      showError(message) {
        const error = this.querySelector('[data-cart-error]')
        if (!error) return
        error.textContent = message
        error.hidden = !message
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-offer')) { customElements.define('countdown-offer', class CountdownOffer extends HTMLElement { connectedCallback(){if(!this.dataset.end)return;this.end=Date.parse(this.dataset.end);if(Number.isNaN(this.end))return;this.update();this.timer=setInterval(this.update,1000)} disconnectedCallback(){clearInterval(this.timer)} update=()=>{const remaining=Math.max(0,this.end-Date.now());const values=[Math.floor(remaining/86400000),Math.floor(remaining/3600000)%24,Math.floor(remaining/60000)%60,Math.floor(remaining/1000)%60];['days','hours','minutes','seconds'].forEach((key,index)=>{const node=this.querySelector(`[data-${key}]`);if(node)node.textContent=String(values[index]).padStart(2,'0')});if(remaining===0){clearInterval(this.timer);this.querySelector('.countdown-offer__timer')?.setAttribute('hidden','');const expired=this.querySelector('[data-expired]');if(expired)expired.hidden=false}} }) }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('storefront-header')) {
    customElements.define('storefront-header', class StorefrontHeader extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.details = [...this.querySelectorAll('.desktop-navigation__details')]
        this.details.forEach((detail) => {
          detail.addEventListener('pointerenter', this.handlePointerEnter)
          detail.addEventListener('pointerleave', this.handlePointerLeave)
          detail.addEventListener('focusout', this.handleFocusOut)
          detail.addEventListener('keydown', this.handleDetailKeydown)
        })
        document.addEventListener('click', this.handleDocumentClick)
        document.addEventListener('cart:updated', this.handleCartUpdated)
      }
      disconnectedCallback() {
        this.details?.forEach((detail) => {
          clearTimeout(detail.closeTimer)
          detail.removeEventListener('pointerenter', this.handlePointerEnter)
          detail.removeEventListener('pointerleave', this.handlePointerLeave)
          detail.removeEventListener('focusout', this.handleFocusOut)
          detail.removeEventListener('keydown', this.handleDetailKeydown)
        })
        document.removeEventListener('click', this.handleDocumentClick)
        document.removeEventListener('cart:updated', this.handleCartUpdated)
        delete this.dataset.ready
      }
      handlePointerEnter = (event) => {
        if (!matchMedia('(min-width: 990px)').matches) return
        const detail = event.currentTarget
        clearTimeout(detail.closeTimer)
        this.details.forEach((item) => { if (item !== detail) item.open = false })
        detail.open = true
      }
      handlePointerLeave = (event) => {
        if (!matchMedia('(min-width: 990px)').matches) return
        const detail = event.currentTarget
        detail.closeTimer = setTimeout(() => { if (!detail.matches(':focus-within')) detail.open = false }, 220)
      }
      handleFocusOut = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) event.currentTarget.open = false
      }
      handleDetailKeydown = (event) => {
        if (event.key !== 'Escape') return
        event.currentTarget.open = false
        event.currentTarget.querySelector('summary')?.focus()
      }
      handleDocumentClick = (event) => {
        if (this.contains(event.target)) return
        this.details.forEach((detail) => { detail.open = false })
      }
      handleCartUpdated = async (event) => {
        const cartData = event.detail?.item_count !== undefined ? event.detail : await this.fetchCart()
        if (cartData) this.updateCartCount(cartData.item_count)
      }
      async fetchCart() {
        try {
          const response = await fetch(this.dataset.cartEndpoint, { headers: { Accept: 'application/json' } })
          if (!response.ok) return null
          return response.json()
        } catch (error) { return null }
      }
      updateCartCount(count) {
        const trigger = this.querySelector('[data-cart-trigger]')
        const badge = this.querySelector('[data-cart-count]')
        if (badge) { badge.textContent = count; badge.hidden = count === 0 }
        if (trigger) {
          const updatedLabel = trigger.dataset.cartLabel.replace('[count]', count)
          trigger.setAttribute('aria-label', updatedLabel)
          const liveRegion = document.getElementById('StorefrontLiveRegion')
          if (liveRegion) liveRegion.textContent = updatedLabel
        }
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('merricrate-hero')) {
    customElements.define('merricrate-hero', class MerricrateHero extends HTMLElement {
      connectedCallback() {
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) return
        this.querySelectorAll('video[autoplay]').forEach((video) => { video.removeAttribute('autoplay'); video.pause() })
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-list-section')) {
    customElements.define('product-list-section', class ProductListSection extends HTMLElement {
      async connectedCallback() {
        if (this.dataset.source !== 'recommendations' || !this.dataset.productId) return
        try {
          const url = new URL(this.dataset.url, location.origin)
          url.searchParams.set('section_id', this.dataset.sectionId)
          url.searchParams.set('product_id', this.dataset.productId)
          url.searchParams.set('limit', this.dataset.limit)
          const response = await fetch(url)
          if (!response.ok) {
            this.hideEmptySection()
            return
          }
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html')
          const next = parsed.querySelector('[data-product-list-grid]')
          const current = this.querySelector('[data-product-list-grid]')
          if (!next || !current) return
          if (!next.children.length) {
            this.hideEmptySection()
            return
          }
          this.closest('.section-frame')?.removeAttribute('hidden')
          current.innerHTML = next.innerHTML
        } catch (error) {
          this.hideEmptySection()
          return
        }
      }

      hideEmptySection() {
        if (this.dataset.designMode !== 'true') this.closest('.section-frame')?.setAttribute('hidden', '')
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  if (!customElements.get('storefront-predictive-search')) {
    customElements.define('storefront-predictive-search', class StorefrontPredictiveSearch extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.input = this.querySelector('[data-predictive-input]')
        this.results = this.querySelector('[data-predictive-results]')
        this.loading = this.querySelector('[data-search-loading]')
        this.error = this.querySelector('[data-search-error]')
        this.input?.addEventListener('input', this.handleInput)
        this.input?.addEventListener('keydown', this.handleInputKeydown)
        this.results?.addEventListener('keydown', this.handleResultsKeydown)
      }
      disconnectedCallback() {
        this.input?.removeEventListener('input', this.handleInput)
        this.input?.removeEventListener('keydown', this.handleInputKeydown)
        this.results?.removeEventListener('keydown', this.handleResultsKeydown)
        clearTimeout(this.searchTimer)
        this.controller?.abort()
        delete this.dataset.ready
      }
      handleInput = () => {
        clearTimeout(this.searchTimer)
        this.controller?.abort()
        const query = this.input.value.trim()
        this.closeResults()
        if (!query || this.dataset.enabled !== 'true') return
        this.searchTimer = setTimeout(() => this.search(query), 250)
      }
      handleInputKeydown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          this.input.form?.requestSubmit()
          return
        }
        if (event.key === 'ArrowDown') {
          const firstOption = this.getOptions()[0]
          if (firstOption) { event.preventDefault(); firstOption.focus() }
        }
        if (event.key === 'Escape') {
          event.preventDefault()
          this.closeSearch()
        }
      }
      handleResultsKeydown = (event) => {
        const options = this.getOptions()
        const index = options.indexOf(document.activeElement)
        if (index < 0) return
        if (event.key === 'ArrowDown') { event.preventDefault(); options[(index + 1) % options.length]?.focus() }
        if (event.key === 'ArrowUp') { event.preventDefault(); options[(index - 1 + options.length) % options.length]?.focus() }
        if (event.key === 'Escape') { event.preventDefault(); this.closeSearch() }
      }
      getOptions() { return [...this.results.querySelectorAll('[data-predictive-option]')] }
      async search(query) {
        this.controller?.abort()
        const controller = new AbortController()
        this.controller = controller
        this.setLoading(true)
        this.showError('')
        try {
          const url = new URL(this.dataset.suggestUrl, window.location.origin)
          url.searchParams.set('q', query)
          url.searchParams.set('section_id', this.dataset.sectionId)
          url.searchParams.set('resources[type]', 'product,collection,page,article')
          url.searchParams.set('resources[limit]', '6')
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } })
          if (!response.ok) throw new Error(this.dataset.errorMessage)
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html')
          const nextResults = documentFragment.querySelector('[data-predictive-search-results]')
          if (!nextResults) throw new Error(this.dataset.errorMessage)
          this.results.innerHTML = nextResults.innerHTML
          this.results.hidden = false
          this.input.setAttribute('aria-expanded', 'true')
        } catch (error) {
          if (error.name !== 'AbortError') { this.closeResults(); this.showError(error.message || this.dataset.errorMessage) }
        } finally { if (this.controller === controller) this.setLoading(false) }
      }
      setLoading(loading) { if (this.loading) this.loading.hidden = !loading; this.input?.setAttribute('aria-busy', loading ? 'true' : 'false') }
      showError(message) { if (!this.error) return; this.error.textContent = message; this.error.hidden = !message }
      closeResults() { if (this.results) { this.results.hidden = true; this.results.innerHTML = '' }; this.input?.setAttribute('aria-expanded', 'false') }
      closeSearch() { this.closeResults(); this.closest('dialog[open]')?.close() }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
